module.exports = __webpack_public_path__ + "static/media/Scherrie P.72462373.jpg";